(() => {
  if (window.voltNavigationCardsLoaded) return;
  window.voltNavigationCardsLoaded = true;
  const cache = new Map();
  const queue = [];
  let running = 0;
  const drain = () => {
    while (running < 3 && queue.length) {
      const job = queue.shift();
      running++;
      job().finally(() => { running--; drain(); });
    }
  };
  const load = href => {
    if (!cache.has(href)) {
      cache.set(href, new Promise((resolve, reject) => {
        queue.push(async () => {
          try {
            const url = new URL(href, location.origin);
            if (url.origin !== location.origin) throw new Error('Invalid category URL');
            url.searchParams.set('section_id', 'volt-navigation-count');
            const response = await fetch(url.pathname + url.search, { headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Category data unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = JSON.parse(html.querySelector('[data-vnm-count-json]').textContent);
            if (!Number.isInteger(data.count) || data.count < 0) throw new Error('Invalid category count');
            resolve(data);
          } catch (error) { reject(error); }
        });
        drain();
      }));
    }
    return cache.get(href);
  };
  const hydrate = card => {
    if (card.dataset.navigationLoading) return;
    card.dataset.navigationLoading = 'true';
    load(card.dataset.navigationUrl).then(data => {
      if (!card.isConnected) return;
      const section = card.closest('[data-navigation-cards]');
      const count = card.querySelector('[data-navigation-count]');
      if (count) {
        const number = String(data.count) + (data.capped ? '+' : '');
        count.textContent = data.count === 1 ? section.dataset.countOne : section.dataset.countOther.replaceAll('[count]', number);
        count.style.visibility = 'visible';
      }
      const placeholder = card.querySelector('.collection-card__placeholder');
      if (placeholder && data.image) {
        const url = new URL(data.image, location.origin);
        if (url.protocol !== 'https:') return;
        const img = document.createElement('img');
        img.src = url.href;
        img.alt = card.querySelector('.collection-card__title')?.textContent.trim() || '';
        img.width = 320;
        img.height = 320;
        img.loading = 'lazy';
        img.className = 'motion-reduce hover-scale-up';
        img.style.objectFit = 'contain';
        placeholder.replaceWith(img);
      }
    }).catch(() => {});
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { observer.unobserve(entry.target); hydrate(entry.target); }
    });
  }, { rootMargin: '600px' });
  const init = (scope = document) => scope.querySelectorAll('[data-navigation-url]:not([data-navigation-observed])').forEach(card => {
    card.dataset.navigationObserved = 'true';
    observer.observe(card);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
